var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"navbar"},[(_setup.back)?_c('div',{staticClass:"return",on:{"click":_setup.back}},[_c('img',{attrs:{"src":require("@/assets/return.png")}})]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }